import { NAModule } from '../NAModule.model';

import { alimentation, autoTrigger, battery, lastActivity, lastSeen, tamperDetection } from '~/helpers/fields-description';
import { statusTempered } from '~/helpers/monkey-fields-description';
import { rfStatus } from '~/helpers/network-fields-description';

export class NIS extends NAModule {
    hasOperationImportData = false;
    hasOperationReset = false;

    battery?: number;
    alim_source?: string;
    status_tampered?: boolean;
    tamper_detection_enabled?: boolean;
    rf_strength?: number;
    monitoring?: string;
    last_activity?: number;

    isWired = false;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery), this.battery);
    }
    get fieldAlimentation() {
        return alimentation(this.alim_source);
    }
    get fieldStatusTampered() {
        return statusTempered(this.status_tampered);
    }
    get fieldTamperDetection() {
        return tamperDetection(this.tamper_detection_enabled, this.getBoolFieldClass(this.tamper_detection_enabled));
    }
    get fieldRfStatus() {
        return rfStatus(this.getRfIcon(this.rf_strength), this.rf_strength);
    }
    get fieldAutoTrigger() {
        return autoTrigger(this.monitoring, this.monitoring === 'on' ? 'success--text' : 'error--text');
    }
    get fieldLastActivity() {
        return lastActivity(this.last_activity);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }

    get column() {
        return 'left';
    }
}
